import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkTable from "../../components/atoms/TkTable";
import { fakeTableList, headTitleList } from "./parts";
import TkButton from "../../components/atoms/TkButton";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { useNavigate, useLocation } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { httpAPI_AGE007, httpAPI_AGE010 } from "./api/request";
import { IAPI_AGE007_Response, IAPI_AGE010_Request } from "../../type/apiType";
import { funInfoBodyList, getUrlPath } from "./hooks/useHooks";
import { HandleStatus, ProcedureName98 } from "../../assets/data/Constants";
import _ from "lodash";
import TkDialog from "../../components/atoms/TkDialog";

/**
 * SCRD310002 依頼内容処理状況管理
 * @return SCRD310002 依頼内容処理状況管理
 */
const SCRD310002 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state;
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [bodyList, setBodyList] = useState<any>();
  const [res, setRes] = useState<IAPI_AGE007_Response>({});
  const [isShow, setIsShow] = useState(false);
  const [formerTaskType, setFormerTaskType] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const taskId = locationState?.taskId ?? businessState.agentRequest?.taskId;
  const applyId = locationState?.applyId ?? businessState.agentRequest?.applyId;
  const businessType = businessState.common?.businessType;
  const [open, setOpen] = useState(false);

  // 確認・修正する場合はこちら(Tbl01) リンク クリック
  const onLinkClick = (res: IAPI_AGE007_Response) => {
    setBusinessState({
      agentRequest: {
        ...businessState.agentRequest,
        taskId,
        applyId: applyId ?? res.applyId,
      },
    });
    navigate(
      getUrlPath(res.formerTaskType!, applyId ?? res.applyId, businessType),
      {
        state: {
          ...locationState,
          staffNo: res.staffNo,
        },
      }
    );
  };

  // 「手続きへ」、「書類の登録」、「源泉徴収票の登録」 ボタン 押下
  const handleNewStaff = (isWithHolding?: boolean) => {
    let jobName = businessType
      ?.toLowerCase()
      .replace("-", "_") as keyof typeof businessState;
    setBusinessState({
      ...businessState,
      [jobName]: {
        ...businessState[jobName],
        applyId: applyId ?? res.applyId,
        facilityNo: res.facilityNo,
        facilityName: res.facilityName,
      },
      agentRequest: {
        ...businessState.agentRequest,
        taskId,
        applyId: applyId ?? res.applyId,
      },
    });

    navigate(
      getUrlPath(formerTaskType, res.applyId, businessType, isWithHolding),
      {
        state: {
          ...locationState,
          applyId: applyId ?? res.applyId,
          staffNo: res.staffNo,
          facilityNo: res.facilityNo,
          facilityName: res.facilityName,
        },
      }
    );
  };

  // 確認ダイアログ 「はい」 押下
  const handleFinishedReport = async () => {
    setOpen(false);
    const paramData: IAPI_AGE010_Request = {
      taskId: res.taskId,
      facilityNo: res.facilityNo,
      formerTaskType: res.formerTaskType,
      taskTitle: res.taskTitle,
      taskText: res.taskText,
    };
    // 代行入力完了更新API 呼び出し
    try {
      const res = await httpAPI_AGE010({
        ...paramData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRD310001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 初期表示
  const handleInit = async () => {
    // 代行入力依頼参照API 呼び出し
    try {
      const res = await httpAPI_AGE007({
        taskId,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;

        // 代行内容
        resArr.find((item) => item.keyword === "formerTaskType")!.text =
          res.formerTaskTypeName;

        // 対象施設
        let facilityName = resArr.find(
          (item) => item.keyword === "facilityName"
        )!;
        facilityName.text =
          (res.facilityNo ?? "") + ":" + (res.facilityName ?? "");
        if (res.formerTaskType === ProcedureName98["退職届（添付待ち）"]) {
          facilityName.showLine =
            res.formerTaskType !== ProcedureName98["退職届（添付待ち）"];
        } else {
          facilityName.showLine =
            res.formerTaskType !== ProcedureName98["退職届"];
        }

        // 退職者名
        let staffName = resArr.find((item) => item.keyword === "staffName")!;
        staffName.text = (res.staffNo ?? "") + ":" + (res.staffName ?? "");
        if (res.formerTaskType === ProcedureName98["退職届（添付待ち）"]) {
          staffName.showLine =
            res.formerTaskType === ProcedureName98["退職届（添付待ち）"];
        } else {
          staffName.showLine = res.formerTaskType === ProcedureName98["退職届"];
        }

        // タイトル
        resArr.find((item) => item.keyword === "title")!.text = res.taskTitle;

        // 本文
        resArr.find((item) => item.keyword === "text")!.node = (
          <div className="text">{res.taskText}</div>
        );

        let isShow = false;
        if (
          res.formerTaskType === ProcedureName98["本俸/調整額の更新"] ||
          res.formerTaskType === ProcedureName98["従業状況の更新"]
        ) {
          isShow = true;
        } else if (
          res.formerTaskType === ProcedureName98["配置換え（対象外異動含む）"]
        ) {
          if (businessType === "JOB-27") {
            isShow = true;
          }
        } else if (
          res.formerTaskType === ProcedureName98["退職届（施設単位）"]
        ) {
          isShow = true;
        }

        setIsShow(isShow);
        setStateTableList(resArr);
        setBodyList(funInfoBodyList(res, onLinkClick));
        setFormerTaskType(res.formerTaskType!);
        setRes(res);
        setBtnDisabled(res.handleStatus === HandleStatus["完了"]);
        setState({
          ...state,
          errorMsgId: "",
        });
        if (res.formerTaskType === ProcedureName98["退職届（添付待ち）"]) {
          setBusinessState({
            ...businessState,
            job_32: {
              ...businessState.job_32,
              facilityNo: res?.facilityNo,
              staffNo: res?.staffNo,
              staffNameKanji: res?.staffName,
              nRetireReasonCd: res?.retireReasonCd,
              retireProcedureReason: res?.retireProcedureReason,
            },
          });
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRD310002" data-testid="SCRD310002PageForTest">
      <TkFakeTable list={stateTableList} ruleSchema={{}} showButton={false} />

      <TkTable
        headList={headTitleList}
        bodyList={bodyList}
        headerLeftComponent={<Box>依頼された作業の詳細</Box>}
      />
      <Box className="content">
        {!(res.attachDocFlg === "1" || res.attachWithholdingFlg === "1") && (
          <Box className="btn">
            <TkButton onClick={() => handleNewStaff()} disabled={btnDisabled}>
              手続きへ
            </TkButton>
          </Box>
        )}
      </Box>
      <Box className="content">
        {res.attachDocFlg === "1" && (
          <Box className="btn">
            <TkButton
              onClick={() => handleNewStaff(false)}
              disabled={btnDisabled}
            >
              書類の登録
            </TkButton>
          </Box>
        )}
      </Box>
      <Box className="content">
        {res.attachWithholdingFlg === "1" && (
          <Box className="btn">
            <TkButton
              onClick={() => handleNewStaff(true)}
              disabled={btnDisabled}
            >
              源泉徴収票の登録
            </TkButton>
          </Box>
        )}
      </Box>
      <Box className="content">
        <Box className={isShow ? "show" : "notShow"}>
          <Box className="btn">{labelids.labelid.LBLD310002_01}</Box>
          <Box className="btn">
            <TkButton onClick={() => setOpen(true)} disabled={btnDisabled}>
              完了報告
            </TkButton>
          </Box>
        </Box>
      </Box>

      <TkDialog
        title="確認（完了を報告します）"
        contextText="　作業を完了とします。よろしいでしょうか？"
        open={open}
        okText="はい"
        cancelText="いいえ"
        onCancel={() => setOpen(false)}
        onSave={() => handleFinishedReport()}
      />
    </Box>
  );
};

export default SCRD310002;
